// Этот файл генерируется автоматически, его не следует редактировать вручную
import form from '@/widgets/form.js';
import globalEventButton from '@/widgets/globalEventButton.js';
import headerScroll from '@/widgets/headerScroll.js';
import mapBlockContact from '@/widgets/mapBlockContact.js';
import popupForm from '@/widgets/popupForm.js';
import popupMenu from '@/widgets/popupMenu.js';
import qrGenerate from '@/widgets/qrGenerate.js';
import scrollDown from '@/widgets/scrollDown.js';
import scrollTop from '@/widgets/scrollTop.js';
import sliderAdvantages from '@/widgets/sliderAdvantages.js';
import sliderArticles from '@/widgets/sliderArticles.js';
import sliderInstructions from '@/widgets/sliderInstructions.js';
import sliderPharmacies from '@/widgets/sliderPharmacies.js';
import sliderWhatDo from '@/widgets/sliderWhatDo.js';
import stageAnimations from '@/widgets/stageAnimations.js';
import videoBlock from '@/widgets/videoBlock.js';
import virusesAnimations from '@/widgets/virusesAnimations.js';

export default {
  'collapse': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/collapse.js'),
  'form': async () => { return { default: form }; },
  'globalEventButton': async () => { return { default: globalEventButton }; },
  'headerScroll': async () => { return { default: headerScroll }; },
  'mapBlockContact': async () => { return { default: mapBlockContact }; },
  'popupForm': async () => { return { default: popupForm }; },
  'popupMenu': async () => { return { default: popupMenu }; },
  'qrGenerate': async () => { return { default: qrGenerate }; },
  'scrollDown': async () => { return { default: scrollDown }; },
  'scrollTop': async () => { return { default: scrollTop }; },
  'sliderAdvantages': async () => { return { default: sliderAdvantages }; },
  'sliderArticles': async () => { return { default: sliderArticles }; },
  'sliderInstructions': async () => { return { default: sliderInstructions }; },
  'sliderPharmacies': async () => { return { default: sliderPharmacies }; },
  'sliderWhatDo': async () => { return { default: sliderWhatDo }; },
  'specPopup': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/specPopup.js'),
  'stageAnimations': async () => { return { default: stageAnimations }; },
  'tabsSwitch': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/tabsSwitch.js'),
  'telephoneMask': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/telephoneMask.js'),
  'videoBlock': async () => { return { default: videoBlock }; },
  'virusesAnimations': async () => { return { default: virusesAnimations }; }
};
